module.exports = __webpack_public_path__ + "front/img/home-kv.3b431698.png";